import { Button, type ButtonProps } from "../shadcn/Button";
import { cn } from "@/shared/utils/cn";

export function SectionAction({ className, ...props }: ButtonProps) {
  return <Button {...props} variant="quiet" size="sm" className={cn("border-0 px-2 text-sm [&_svg]:hidden", className)} />;
}
